import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-task-list-dialog',
  templateUrl: './task-list-dialog.component.html',
  styleUrls: ['./task-list-dialog.component.css']
})
export class TaskListDialogComponent implements OnInit {

  options: any
  today : any
  currentDate : any

  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;

  shown: 'native' | 'hover' | 'always' = 'native';

  constructor() { }

  ngOnInit(): void {

    this.options = {
      month : 'short',
      day : 'numeric',
      year : 'numeric'
    }
  
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US",this.options)
  }

}
